"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AZURE_BASE_URL_HOST = 'https://api.wbmi.com';
var AZURE_BASE_URL = AZURE_BASE_URL_HOST + '/insured';
var LIFERAY_BASE_URL = 'https://insured.thesilverlining.com';
var REGISTRATION_URL = AZURE_BASE_URL + '/user';
var POLICY_URL = AZURE_BASE_URL + '/policy';
var INVOICE_URL = AZURE_BASE_URL + '/user/profile/invoice-history';
var ACCOUNT_URL = AZURE_BASE_URL + '/user/profile';
var AGENCY_URL = AZURE_BASE_URL + '/agency/';
var CLAIM_URL = AZURE_BASE_URL + '/claim';
// const CLAIM_URL_ASP = AZURE_BASE_URL + '/policy-claim';
var NOTIFICATION_URL = AZURE_BASE_URL + '/notification';
var HONEYPOT_CODE = 'wbmi1975432018';
var APIMSUBSKEY = '01b54619ea74464f8ba074cabb0e54e3';
var insuredSessionId = null;
if (window.Liferay && window.Liferay.InsuredSessionId) {
  insuredSessionId = window.Liferay.InsuredSessionId;
}
// front end request timeout in ms. Used in fetch.js
var FRONTEND_REQUEST_TIMEOUT = 30000;
var API_PROD = {
  FRONTEND_REQUEST_TIMEOUT: FRONTEND_REQUEST_TIMEOUT,
  LIFERAY_BASE_URL: LIFERAY_BASE_URL,
  OKTA: {
    baseUrl: 'https://wbmi.okta.com',
    clientId: '0oa8x0471frJ2yw8W1t7',
    redirectUri: 'com.wbmi.mobile:/callback',
    codeVerifier: 'M25iVXpKU3puUjFaYWg3T1NDTDQtcW1ROUY5YXlwalNoc0hhakxifmZHag',
    codeChallenge: 'qjrzSW9gMiUgpUvqgEPE4_-8swvyCtfOVvg55o5S_es',
    stateParam: 'state-8600b31f-52d1-4dca-987c-386e3d8967e9',
    token: '00mS8zZ8o1Alqe28PxTMUFovcoPGA57v-Au1Lv2iaP'
  },
  REGISTRATION: {
    verifyUrl: REGISTRATION_URL + '/verifyuser',
    registerUrl: REGISTRATION_URL + '/register',
    checkStatusUrl: REGISTRATION_URL + '/isactive',
    resendEmailUrl: REGISTRATION_URL + '/resend-email',
    changeEmailUrl: REGISTRATION_URL + '/change-email',
    resetPasswordUrl: REGISTRATION_URL + '/reset-password',
    getPolicyTypeUrl: REGISTRATION_URL + '/getpolicytype'
  },
  ACCOUNT: {
    accountUrl: ACCOUNT_URL + '/account',
    profileAccountUrl: ACCOUNT_URL + '/account',
    billingAccountUrl: ACCOUNT_URL + '/account/paperless-billing',
    notificationsUrl: ACCOUNT_URL + '/account/notifications',
    accountOwnerURL: ACCOUNT_URL + '/user-access',
    paperlessSettingsUrl: ACCOUNT_URL + '/paperless-setting-summary',
    paperlessUpdateUrl: ACCOUNT_URL + '/update-paperless-setting'
  },
  NOTIFICATIONS: {
    notificationsUrl: NOTIFICATION_URL
  },
  POLICY: {
    policyUrl: POLICY_URL,
    policyBilling: 'billing',
    policyDocuments: 'documents',
    coverageForms: 'coverage-form-list',
    policyVehicleList: 'vehicle-list',
    associatePolicy: REGISTRATION_URL + '/associate-policy',
    associatePolicyGetSecurityQuestions: REGISTRATION_URL + '/policy/associate',
    associatePolicyPostSecurityQuestions: REGISTRATION_URL + '/policy/associate/validate',
    unlinkPolicyUrl: ACCOUNT_URL + '/unlink/'
  },
  INVOICE: {
    invoiceURL: INVOICE_URL
  },
  CONTENT: {
    getContentUrl: AZURE_BASE_URL + '/article/category/'
  },
  AGENCY: {
    getAgencyUrl: AGENCY_URL
  },
  CLAIMS: {
    claimUrl: POLICY_URL,
    imageUrl: CLAIM_URL + '/photo/base64'
  },
  PAYBILL: {
    payBillUrl: 'https://wbmi.okta.com/home/westbendmutualinsurancecompany_insuredfiscustomerconsole_1/0oa91rsfnyL28O69T1t7/aln91rwltvOFSopR01t7',
    billingStaticWebAppDomain: 'billing.wbmi.com'
  },
  HONEYPOT: HONEYPOT_CODE,
  CONFIG: {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'ocp-apim-subscription-key': APIMSUBSKEY
    }
  },
  ADD_AUTH_HEADER: function ADD_AUTH_HEADER(config, auth) {
    if (auth && auth.token && auth.token.access_token) {
      config.headers = Object.assign({}, config.headers, {
        Authorization: 'Bearer ' + auth.token.access_token
      });
    } else if (insuredSessionId) {
      config.headers = Object.assign({}, config.headers, {
        Authorization: 'Portal ' + insuredSessionId
      });
    }
    return config;
  },
  ADD_VERSION_HEADER: function ADD_VERSION_HEADER(config, data) {
    if (data) {
      if (data.apiVersion) {
        config.headers = Object.assign({}, config.headers, {
          Accept: 'application/vnd.wbmi.policy.v' + data.apiVersion + '+json'
        });
      } else if (config.headers.Accept !== 'application/json') {
        config.headers.Accept = 'application/json';
      }
    }
    return config;
  },
  GOOGLE_API: {
    mapGeocodeUrl: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCONlEHI3x1J73YYAI1G4E6kxgNdqLxDC8&address=',
    mapsApiKey: 'AIzaSyCONlEHI3x1J73YYAI1G4E6kxgNdqLxDC8',
    analyticsTrackerId: 'UA-130432720-1',
    analyticsTrackerInterval: 30
  },
  FEEDBACK_URL: 'https://westbend.allegiancetech.com/cgi-bin/qwebcorporate.dll?idx=W23QUA'
};
var _default = exports.default = API_PROD;